/**
 * Number characters
 */
export const NUMBERS = '0123456789'

export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'

export const ALPHABET_UPPER = ALPHABET.toUpperCase()

export const HEX = 'abcdef'

export const BINARY = '01'

export const OCTAL = '01234567'
